import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play2",
  "use": "play2-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 90 90\" id=\"play2\">\n  <path fill=\"currentColor\" d=\"M45 12a33 33 0 1 1-33 33 33.05 33.05 0 0 1 33-33Zm0-7a40 40 0 1 0 0 80 40 40 0 0 0 0-80Z\" />\n  <path fill=\"currentColor\" d=\"M57.75 46.1 38.4 57.25a1.25 1.25 0 0 1-1.85-1.1V33.8a1.251 1.251 0 0 1 1.9-1.1L57.8 43.9a1.25 1.25 0 0 1-.05 2.2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol